import { z } from 'zod'
import { describeIssues, reportContractIssue } from '@/helpers/contractLog'

/**
 * Lista da API lida item por item: o item que não passa no schema é descartado e registrado (console e Sentry, sem os
 * valores), e os outros seguem. Um produto com slug nulo na vitrine, um endereço antigo ou um item do carrinho com a
 * cópia do produto incompleta não derrubam a resposta inteira. Lista nula ou ausente vira `[]`; o que não é lista
 * continua reprovando (erro de contrato da resposta).
 *
 * `label` diz no registro de que lista o item saiu (ex.: `'produtos da listagem'`).
 */
export function tolerantArray<T extends z.ZodType>(item: T, label: string) {
    return z
        .array(z.unknown())
        .nullish()
        .transform((values) => {
            const kept: z.output<T>[] = []
            const discarded: string[] = []
            for (const [index, value] of (values ?? []).entries()) {
                const parsed = item.safeParse(value)
                if (parsed.success) kept.push(parsed.data)
                else discarded.push(...describeIssues(parsed.error.issues, `[${index}] `))
            }
            if (discarded.length > 0) {
                reportContractIssue(`Itens descartados de ${label} (fora do contrato)`, discarded, 'warning')
            }
            return kept
        })
}
